<template>
  <q-checkbox
    :value="vModel"
    v-bind="$attrs"
    class="relative-position"
    v-on="$listeners"
  >
    <slot />
    <span
      v-if="hint"
      class="absolute-bottom text-caption text-center no-pointer-events"
      style="bottom: -10px"
    >
      {{ hint }}
    </span>
  </q-checkbox>
</template>

<script>
/**
 * Proxy le composant QCheckbox avec un model à false par défaut
 * @extends QToggle
 */
export default {
  name: 'LwfCheckbox',
  props: {
    /**
     * @model
     */
    value: {
      type: [Boolean, Array],
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    indeterminate: Boolean
  },
  computed: {
    vModel () {
      return this.indeterminate
        ? this.value
        : !!this.value
    }
  }
}
</script>

<style scoped>

</style>
